import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;    
`;

export const Form = styled.form`
  width: 400px;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -90px;

  img {
    width: 80px;
    height: 75px;
    margin: 10px 0 10px;    
  }
  p {
    color: #ff3333;
    margin-bottom: 15px;
    border: 1px solid #ff3333;
    padding: 10px;
    width: 100%;
    text-align: center;
  }
  input {
    flex: 1;    
    margin-bottom: 8px;
    padding: 0 5px;
    color: #777;
    font-size: 17px;
    width: 100%;        
    border: 1px solid #ddd;
    &::placeholder {
      color: #999;
    }
  }
  button {
    color: #fff;
    font-size: 16px;
    background: #fc6963;
    height: 35px;
    border: 0;
    border-radius: 5px;
    width: 100%;
  }
  hr {
    margin: 20px 0;
    border: none;
    border-bottom: 1px solid #cdcdcd;
    width: 100%;
  }
  a {
    font-size: 16;
    font-weight: bold;
    color: #999;
    text-decoration: none;
  }
`;

export const Label = styled.label`
    font-weight: bold;       
`;

export const NomeEmpresa = styled.label`
    font-weight: bold; 
    color: #0B3861;
    font-size: 20px;
    margin-bottom: 15px
`;